import { ModalCustom } from "components/ModalCustom";
import { FaCheck } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
}

export function ModalSucessoRemoverCusto({ show, handleClose }: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Remover custo"
      centered
      zIndex={1070}
    >
      <div style={{ textAlign: "center", padding: "8px 0" }}>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 16,
            background: "#e6f9f0",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 12,
          }}
        >
          <FaCheck style={{ color: "#28a745", fontSize: "1.8rem" }} />
        </div>
        <p style={{ marginBottom: 0 }}>Custo removido!</p>
      </div>
    </ModalCustom>
  );
}
